import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".Textarea-module_textarea__yw5Mo {\n  display: flex;\n  width: 100%;\n  min-height: 40px;\n  border: 1px solid #b1b5b9;\n  border-radius: 5px;\n  padding: 16px;\n  background: #ffffff;\n  box-shadow: 0 1px 1px rgba(9, 10, 11, 0.05);\n  resize: vertical;\n}\n.Textarea-module_textareaError__beLXM {\n  border: 1px solid #bd2d00;\n}\n\n.Textarea-module_maxLengthMsg__ilktQ {\n  color: #090a0b;\n}";
var styles = {"textarea":"Textarea-module_textarea__yw5Mo","textareaError":"Textarea-module_textareaError__beLXM","maxLengthMsg":"Textarea-module_maxLengthMsg__ilktQ"};
styleInject(css_248z);

export { styles as default };
